var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _rect10, _rect11, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _rect17, _path5, _rect18, _rect19, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFindYourTracks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 474,
    viewBox: "0 0 683 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H682V444C682 460.569 668.569 474 652 474H0V4Z",
    fill: "#21232B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 184,
    height: 418,
    fill: "#020203",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 95,
    width: 156,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 71,
    width: 40,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 191,
    width: 149,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 215,
    width: 153,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 239,
    width: 118,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 119,
    width: 115,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 143,
    width: 131,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 167,
    width: 92,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H682V56H0V4Z",
    fill: "#141519"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 120,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 376,
    width: 499,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184 440H682V444C682 460.569 668.569 474 652 474H184V440Z",
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 184,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 248,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 56,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 312,
    width: 499,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 56,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M518 315C518 313.343 519.343 312 521 312H682V372H521C519.343 372 518 370.657 518 369V315Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 120,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M626 379C626 377.343 627.343 376 629 376H682V436H629C627.343 436 626 434.657 626 433V379Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 184,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 248,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28.0013V23H34.9452L38.3867 28.0012H50.666V33H41.7385L38.2969 28.0013H17Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1895_28582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 225,
    width: 220,
    height: 44,
    rx: 4,
    fill: "#C1C5DD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5 242.875L346.5 250.937",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.249 244.375L350.249 249.437",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 240.438L354 253.562",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.75 236.312L357.75 257.687",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.499 240.25L361.499 253.562",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25 238L365.25 255.812",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.999 242.875L368.999 251.312",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.75 241.188L372.75 252.812",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5 245.125L376.5 248.687",
    stroke: "#141519",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.867 252V242.926H391.795V244.33H387.57V246.696H391.379V248.1H387.57V252H385.867ZM394.847 252V250.726H396.888V244.2H394.847V242.926H400.619V244.2H398.578V250.726H400.619V252H394.847ZM405.335 245.487H405.205V252H403.749V242.926H405.842L408.221 249.439H408.351V242.926H409.807V252H407.714L405.335 245.487ZM412.872 242.926H415.693C416.872 242.926 417.747 243.316 418.319 244.096C418.9 244.876 419.19 245.998 419.19 247.463C419.19 248.936 418.9 250.063 418.319 250.843C417.747 251.614 416.872 252 415.693 252H412.872V242.926ZM415.576 250.635C416.2 250.635 416.659 250.431 416.954 250.024C417.257 249.617 417.409 249.023 417.409 248.243V246.67C417.409 245.899 417.257 245.309 416.954 244.902C416.659 244.495 416.2 244.291 415.576 244.291H414.549V250.635H415.576ZM434.758 244.33V252H433.068V244.33H430.338V242.926H437.488V244.33H434.758ZM444.284 248.1H441.632V252H439.929V242.926H441.632V246.696H444.284V242.926H445.987V252H444.284V248.1ZM449.182 252V242.926H454.915V244.33H450.885V246.696H454.772V248.1H450.885V250.596H454.915V252H449.182ZM470.938 244.33V252H469.248V244.33H466.518V242.926H473.668V244.33H470.938ZM477.981 252H476.278V242.926H479.723C480.607 242.926 481.283 243.177 481.751 243.68C482.219 244.183 482.453 244.867 482.453 245.734C482.453 246.401 482.297 246.965 481.985 247.424C481.681 247.875 481.244 248.161 480.672 248.282L482.609 252H480.737L479.008 248.477H477.981V252ZM479.372 247.151C479.831 247.151 480.16 247.06 480.36 246.878C480.559 246.687 480.659 246.388 480.659 245.981V245.487C480.659 245.08 480.559 244.785 480.36 244.603C480.16 244.412 479.831 244.317 479.372 244.317H477.981V247.151H479.372ZM490.119 252L489.482 249.699H486.791L486.167 252H484.451L486.999 242.926H489.365L491.926 252H490.119ZM488.195 244.603H488.091L487.09 248.308H489.196L488.195 244.603ZM497.461 252.156C496.274 252.156 495.394 251.749 494.822 250.934C494.259 250.119 493.977 248.962 493.977 247.463C493.977 245.972 494.259 244.82 494.822 244.005C495.394 243.182 496.274 242.77 497.461 242.77C497.912 242.77 498.306 242.831 498.644 242.952C498.991 243.073 499.29 243.242 499.541 243.459C499.793 243.667 500.001 243.923 500.165 244.226C500.33 244.521 500.46 244.846 500.555 245.201L498.995 245.643C498.935 245.435 498.865 245.24 498.787 245.058C498.709 244.876 498.61 244.72 498.488 244.59C498.376 244.451 498.233 244.347 498.059 244.278C497.886 244.2 497.678 244.161 497.435 244.161C496.846 244.161 496.421 244.386 496.161 244.837C495.91 245.288 495.784 245.903 495.784 246.683V248.243C495.784 249.023 495.91 249.638 496.161 250.089C496.421 250.54 496.846 250.765 497.435 250.765C497.678 250.765 497.886 250.73 498.059 250.661C498.233 250.583 498.376 250.479 498.488 250.349C498.61 250.21 498.709 250.05 498.787 249.868C498.865 249.686 498.935 249.491 498.995 249.283L500.555 249.725C500.46 250.08 500.33 250.41 500.165 250.713C500.001 251.008 499.793 251.263 499.541 251.48C499.29 251.688 498.991 251.853 498.644 251.974C498.306 252.095 497.912 252.156 497.461 252.156ZM505.973 248.022L505.024 249.27V252H503.321V242.926H505.024V247.008H505.102L506.155 245.5L508.066 242.926H509.99L507.143 246.748L510.12 252H508.196L505.973 248.022ZM515.213 252.156C514.433 252.156 513.766 252.022 513.211 251.753C512.665 251.484 512.219 251.129 511.872 250.687L512.899 249.621C513.237 250.011 513.601 250.301 513.991 250.492C514.39 250.674 514.815 250.765 515.265 250.765C515.785 250.765 516.184 250.648 516.461 250.414C516.739 250.18 516.877 249.842 516.877 249.4C516.877 249.036 516.773 248.763 516.565 248.581C516.357 248.39 516.006 248.256 515.512 248.178L514.55 248.022C513.71 247.875 513.112 247.571 512.756 247.112C512.401 246.644 512.223 246.094 512.223 245.461C512.223 244.594 512.505 243.931 513.068 243.472C513.632 243.004 514.412 242.77 515.408 242.77C516.119 242.77 516.73 242.883 517.241 243.108C517.761 243.333 518.177 243.641 518.489 244.031L517.488 245.097C517.246 244.811 516.955 244.586 516.617 244.421C516.279 244.248 515.881 244.161 515.421 244.161C514.433 244.161 513.939 244.568 513.939 245.383C513.939 245.73 514.043 245.994 514.251 246.176C514.459 246.358 514.815 246.492 515.317 246.579L516.266 246.748C517.055 246.895 517.64 247.186 518.021 247.619C518.403 248.052 518.593 248.607 518.593 249.283C518.593 249.708 518.52 250.098 518.372 250.453C518.225 250.8 518.008 251.103 517.722 251.363C517.436 251.614 517.081 251.809 516.656 251.948C516.24 252.087 515.759 252.156 515.213 252.156Z",
    fill: "#141519"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1895_28582",
    x: 322,
    y: 225,
    width: 222,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1895_28582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1895_28582",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindYourTracks);
export default __webpack_public_path__ + "static/media/find-your-tracks.f07daac65c93f644f9af4f339a28cf5a.svg";
export { ForwardRef as ReactComponent };